<template>
  <nav :class="{ open: hovered }" @mouseenter="hover" @mouseleave="unhover">
    <header>
      <router-link to="/">
        <EALogo />
        <p><span>D</span><span>igital&nbsp;</span> <span>A</span><span>sset&nbsp;</span> <span>M</span><span>anager </span></p>
      </router-link>
    </header>
    <ul>
      <li>
        <router-link to="/" exact>
          <span class="icon"><icon-speed-fast /></span>
          <span class="label">{{ $t('nav.dashboard') }}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/media">
          <span class="icon"><icon-pictures /></span>
          <span class="label">{{ $t('nav.media') }}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/chargers">
          <span class="icon"><icon-cord /></span>
          <span class="label">{{ $t('nav.chargers') }}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/partners">
          <span class="icon"><icon-profile /></span>
          <span class="label">{{ $t('nav.partners') }}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/sky/location">
          <span class="icon"><icon-cloud /></span>
          <span class="label">{{ $t('nav.sky') }}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/users">
          <span class="icon"><icon-user /></span>
          <span class="label">{{ $t('nav.users') }}</span>
        </router-link>
      </li>
      <!-- <li>
        <router-link to="/reports">
          <span class="icon"><icon-document /></span>
          <span class="label">{{ $t('nav.reports') }}</span>
        </router-link>
      </li> -->
    </ul>
    <language-switcher />
    <footer>
      <ul>
        <li>
          <router-link to="/logout">
            <span class="icon"><icon-exit-left /></span>
            <span class="label">{{ $t('nav.logout') }}</span>
          </router-link>
        </li>
      </ul>
    </footer>
  </nav>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher'
import EALogo from '@/assets/images/electrifyamerica_logo.svg'
import IconSpeedFast from '@/assets/images/icons/0567-speed-fast.svg'
import IconPictures from '@/assets/images/icons/0274-pictures.svg'
import IconCord from '@/assets/images/icons/0448-cord.svg'
import IconProfile from '@/assets/images/icons/0284-profile.svg'
import IconUser from '@/assets/images/icons/0287-user.svg'
// import IconDocument from '@/assets/images/icons/0217-document.svg'
import IconExitLeft from '@/assets/images/icons/0766-exit-left.svg'
import IconCloud from '@/assets/images/icons/cloud.svg'

export default {
  name: 'AppNav',
  components: {
    LanguageSwitcher,
    EALogo,
    IconSpeedFast,
    IconPictures,
    IconCord,
    IconProfile,
    IconUser,
    // IconDocument,
    IconExitLeft,
    IconCloud
  },
  myTimeout: null,
  data() {
    return {
      hovered: false
    }
  },
  methods: {
    hover() {
      this.$options.myTimeout = setTimeout(() => { this.hovered = true }, 1000);
    },
    unhover() {
      clearTimeout(this.$options.myTimeout);
      this.hovered = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
nav {
  color: #fff;
  background-color: #0B0F4D;
  display: flex;
  flex: 0 0 95px;
  flex-direction: column;
  overflow: hidden;
  padding: 50px 0 30px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 95px;
  transition: all 300ms;
  z-index: 998;

  a {
    font-weight: 300;
  }

  header {
    font-weight: 300;
    padding: 0 30px;

    p {
      margin: em(10) 0 0 0;
      white-space: nowrap;
      transition: margin-left 300ms;

      span:nth-child(2n+2) {
        display: inline-block;
        opacity: 0;
        max-width: 0;
        transition: opacity 300ms, max-width 300ms;
      }
    }
    
    svg {
      width: 156px;
      height: 67px;

      .st0 {
        opacity: 0;
        transition: opacity 300ms;
      }
    }
  }

  ul {
    font-weight: 300;
    margin: 40px 0 0;
    padding: 0;

    li {
      text-align: left;
      white-space: nowrap;
      list-style-type: none;

      a {
        display: flex;
        align-items: center;
        padding: 14px 0 14px 36px;

        &:hover,
        &:active,
        &.router-link-active {
          background-color: rgba(53, 189, 209, 0.15);
        }

        &.router-link-active {
          font-weight: 600;
        }

        .label {
          opacity: 0;
          transition: opacity 300ms;
        }
      }
    }
  }

  .icon {
    display: inline-block;
    margin-right: 6px;
    width: em(24);
    height: em(24);
    flex: 0 0 em(24);

    svg {
      fill: currentColor;
    }
  }

  .language-switcher {
    margin-top: 14px;
    opacity: 0;
    transition: opacity 300ms;

    ::v-deep {
      li.title {
        background-color: #05083B;
        margin: 0 0 27px;
        padding: 16px 16px 16px 36px;

        &::before {
          display: none;
        }
      }
      li {
        line-height: 20px;
        margin: 15px 0 0 36px;
        padding-left: 36px;
        position: relative;

        &::before {
          content: '';
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 0;
          width: 18px;
          height: 18px;
        }
        &::after {
          content: '';
          background: #35BDD1;
          border-radius: 50%;
          opacity: 0;
          position: absolute;
          top: 5px;
          left: 5px;
          width: 10px;
          height: 10px;
          z-index: 2;
          transition: opacity 200ms;
        }
        &.active::after {
          opacity: 1;
        }
      }
    }
  }

  footer {
    margin-top: auto;

    ul {
      margin-top: 0;
    }
  }

  a {
    color: inherit;
  }

  &.open {
    width: 225px;

    header {
      padding-right: 39px;

      p {
        margin-left: 6px;
        
        span:nth-child(2n+2) {
          opacity: 1;
          max-width: em(50);
        }
      }

      svg .st0 {
        opacity: 1;
      }
    }

    ul li a .label {
      opacity: 1;
    }
    .language-switcher {
      opacity: 1;
    }
  }
}
</style>
